import { render, staticRenderFns } from "./enterprise_business_area.vue?vue&type=template&id=ba5e6bc4&scoped=true&"
import script from "./enterprise_business_area.vue?vue&type=script&lang=js&"
export * from "./enterprise_business_area.vue?vue&type=script&lang=js&"
import style0 from "./enterprise_business_area.vue?vue&type=style&index=0&id=ba5e6bc4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba5e6bc4",
  null
  
)

export default component.exports